import { useRef } from 'react'
import type { Chart as ChartJS, ChartType } from 'chart.js'

// A ref for a card's chart, and the PNG of it as drawn for Card's Export
// image. Null until the chart has mounted.
export function useChartExport<TType extends ChartType>() {
  const chartRef = useRef<ChartJS<TType>>()
  const exportImage = (): string | null => chartRef.current?.toBase64Image() ?? null

  return { chartRef, exportImage }
}
